import React, { useRef, useState, useEffect } from 'react';
import { useUsuario } from '../../context/usuarioContext';
import { useNavigate } from 'react-router-dom';
// Componentes UI
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
// Componentes
import Permiso from '../../components/wrappers/permiso';
import TableLayout from "../../layouts/layout-tabla";
// Datos
import { obtenerRevisiones, obtenerRevision } from '../../services/mecanicaService.js'; 
// Utils
import estructurarDatos from '../../utils/estructurarDatos/informeVehiculoTaller.js';
import { formatFecha } from '../../utils/dateFormatter';
import { exportarExcel } from '../../utils/exportarExcel'
import { exportarPDF } from '../../utils/pdf/pdfDataTable';
import { generarPDF } from "../../utils/pdf/pdfInformeMantencion.js";
// Estilos y Assets
import useMedia from '../../hooks/media-querys'
import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import "./ver-informes.css";

export function VerInformes() {
  const isPhone  = useMedia('(max-width: 640px)');
  const labelPdf   = isPhone ? 'PDF'   : 'Exportar PDF';
  const labelExcel = isPhone ? 'Excel' : 'Exportar Excel';
  const fixWidth = isPhone ? "140px" : "auto";
  const fixSize = isPhone ? "0.75rem" : "1rem";

  const { tienePermiso } = useUsuario();
  // const puedeEditar = tienePermiso('Taller Mecánico', 'MEC_EDITAR_INFORME');
  const puedeVerDet = tienePermiso('Taller Mecánico', 'MEC_VER_DETINFORME');
  
  const toast = useRef(null);
  const dt = useRef(null);
  const navigate = useNavigate();

  const [filtroEmpresa, setFiltroEmpresa] = useState('TODOS');
  const [informes, setInformes] = useState([]);
  const informesFiltrados = filtroEmpresa === 'TODOS'
  ? informes
  : informes.filter(i => i.Empresa === filtroEmpresa);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await obtenerRevisiones();

        const datosFormateados = data.map(item => ({
          ...item,
          // FechaIngreso: formatFecha(item.FechaIngreso, '/'),
          // FechaSalida: formatFecha(item.FechaSalida, '/'),
          // CreadoEn: formatFecha(item.CreadoEn, '/'),
        }));

        setInformes(datosFormateados);
      } catch (error) {
        toast.current.show({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'No se pudieron cargar los informes.', 
          life: 3000 
        });
      }
    };

    fetchData();
  }, []);

  // Barra de Busqueda
  const [filters, setFilters] = useState({ 
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [filteredvalue, setFilteredvalue] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);

    // Registros filtrados
    const filtrado = informes.filter((item) => {
      return Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase())
      );
    });
    setFilteredvalue(filtrado);
  };

  // Utilidad: detectar iOS/iPadOS (incluye iPad con userAgent de Mac)
  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const verInforme = (ot) => {
    // 1) Pre-abrir la ventana para no perder el gesto del usuario
    const win = window.open('', '_blank');
    if (!win) {
      toast.current.show({
        severity: 'warn',
        summary: 'Pop-up bloqueado',
        detail: 'Habilita las ventanas emergentes para ver el PDF.',
        life: 4000
      });
      return;
    }

    (async () => {
      try {
        const datos = await obtenerRevision(ot);

        const data = estructurarDatos(datos);

        if (!data) throw new Error('No se recibieron datos');

        const pdf = generarPDF(data);

        if (isIOS()) {
          // 2) iOS: usar Blob + object URL
          pdf.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            // asignar a la ventana ya abierta
            win.location = url;
            // (opcional) liberar URL cuando la ventana cargue
            win.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });
          });
        } else {
          // 3) Otros navegadores: abrir dentro de la misma ventana pre-abierta
          pdf.open({}, win);
        }
        
      } catch (error) {
        // cerrar la ventana pre-abierta si algo falla
        try { win.close(); } catch {}
        toast.current.show({ severity: 'error', summary: 'Error', life: 3000,
          detail: `Error al cargar el informe: ${ot || 'desconocido'}.`
        });
        console.error('Error cargando informe:', error);
      }
    })();
  };

  // Accion Botton
  const accionTemplate = (rowData) => (
    <div className="accion-container" style={{ textAlign: 'center' }}>
      <Button 
        className="btn-editar" 
        icon="pi pi-eye"
        tooltip="Ver"
        tooltipOptions={{ position: 'top' }}
        onClick={() => { verInforme(rowData.NumeroOT) }}
        disabled={!puedeVerDet}
      />
      {/* <Button 
        className="btn-editar" 
        icon="pi pi-pencil"
        tooltip="Editar"
        tooltipOptions={{ position: 'top' }}
        onClick={() => navigate(`/app/taller/editar/revision-vehicular/${rowData.NumeroOT}`)}
        disabled={!puedeEditar}
      /> */}
    </div>
  );

  // Cliente
  const clienteTemplate = (rowData) => {
    return (
      <div style={{ textAlign: 'center' }}>
        <strong>{rowData.ClienteNombre}</strong>
        <><br />
          <small className="text-muted">
            {rowData.ClienteRUT}
          </small>
        </>
      </div>
    );
  };

  // Mecánico
  const mecanicoTemplate = (rowData) => {
    return (
      <div style={{ textAlign: 'center' }}>
        {rowData.Mecanico} 
        {(rowData.Mecanico2) && <>,<br />{rowData.Mecanico2} </> }
      </div>
    );
  };

  const formatMecanicoExport = (r) => {
    if (r.Mecanico2) { return `${r.Mecanico},\n${r.Mecanico2}`; } else { return `${r.Mecanico}`; }
  };

  const formatClienteExport = (r) => {
    if (r.ClienteNombre) { return `${r.ClienteNombre}\n${r.ClienteRUT}`; } else { return ''; }
  };

  // Helpers
  const asText = (v) => (v == null ? '' : String(v));

  // === Columnas para .xlsx ===
  const columnasExcel = [
    { header: 'Creado en',      key: 'CreadoEn',      width: 16, get: r => formatFecha(r['CreadoEn'], '/') },
    { header: 'N°OT',           key: 'NumeroOT',      width: 10, get: r => asText(r['NumeroOT']) },
    { header: 'Empresa',        key: 'Empresa',       width: 22, get: r => asText(r['Empresa']) },
    { header: 'Mecánico',       key: 'Mecanico',      width: 22, get: r => asText(r['Mecanico']) },
    { header: 'Segundo Mecánico', key: 'Mecanico2',   width: 22, get: r => asText(r['Mecanico2']) },
    { header: 'Servicio',       key: 'Servicio',      width: 22, get: r => asText(r['Servicio']) },
    { header: 'Patente',        key: 'Patente',       width: 14, get: r => asText(r['Patente']) },
    { header: 'Modelo',         key: 'Modelo',        width: 20, get: r => asText(r['Modelo']) },
    { header: 'Marca',          key: 'Marca',         width: 18, get: r => asText(r['Marca']) },
    { header: 'Fecha Ingreso',  key: 'FechaIngreso',  width: 16, get: r => formatFecha(r['FechaIngreso'], '/') },
    { header: 'Fecha Salida',   key: 'FechaSalida',   width: 16, get: r => formatFecha(r['FechaSalida'], '/') },
    { header: 'Cliente',        key: 'ClienteNombre', width: 24, get: r => asText(r['ClienteNombre']) },
    { header: 'RUT',            key: 'ClienteRUT',    width: 18, get: r => asText(r['ClienteRUT']) },
    { header: 'Celular',        key: 'ClienteCelular',width: 18, get: r => asText(r['ClienteCelular']) },
  ];
  // === Columnas para .pdf ===
  const columnasPDF = [
    { header: 'N°OT',           get: r => ({ text: asText(r.NumeroOT) })},
    { header: 'Mecánico',       get: r => formatMecanicoExport(r), width: 85},
    { header: 'Servicio',       get: r => ({ text: asText(r.Servicio) }), width: 55},
    { header: 'Patente',        get: r => ({ text: asText(r.Patente) }), width: 40},
    { header: 'Modelo',         get: r => ({ text: asText(r.Modelo) }), width: 40},
    { header: 'Marca',          get: r => ({ text: asText(r.Marca) }), width: 40},
    { header: 'Fecha Ingreso',  get: r => ({ text: formatFecha(r.FechaIngreso, '/') }), width: 55},
    { header: 'Fecha Salida',   get: r => ({ text: formatFecha(r.FechaSalida, '/') }), width: 55},
    { header: 'Cliente',        get: r => formatClienteExport(r), width: 80},
    { header: 'Celular',        get: r => ({ text: asText(r.ClienteCelular) })},
  ];

  // Toolbar 
  const startToolbar = () => (
    <div className="tmc-toolbar-group">
      {['TODOS', 'Transkyrios', 'Servikyrios'].map((opcion) => (
        <Button
          key={opcion}
          label={opcion === 'TODOS' ? 'Todos' : opcion}
          className={filtroEmpresa === opcion ? 'btn-empresa-activo' : 'btn-empresa'}
          onClick={() => {
            setFiltroEmpresa(opcion);
            setGlobalFilterValue('');
            setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
            setFilteredvalue([]);
          }}
        />
      ))}
    </div>
  );

  const endToolbar = () => {
    const nombreArchivo = 'resumen-informe-revision';
    const tituloArchivo = 'RESUMEN: RECEPCIÓN DE VEHÍCULOS';
    const subTituloArchivo = 'TALLER MECÁNICO';
    const rows  = filteredvalue.length > 0 ? filteredvalue : informesFiltrados;

    return(
      <div className='tmc-toolbar-group'>
        <Permiso modulo="Taller Mecánico" permiso="MEC_EXPORTAR_PDF">
          <Button 
            className="btn-pdf" 
            label={labelPdf}
            style={{ fontSize: fixSize, width: fixWidth }}
            icon="pi pi-file-pdf"
            onClick={() =>
              exportarPDF({ rows, columns: columnasPDF, nombreArchivo, tituloArchivo, subTituloArchivo })
            }
          />
        </Permiso>

        <Permiso modulo="Taller Mecánico" permiso="MEC_EXPORTAR_EXCEL">
          <Button
            className="btn-excel"
            label={labelExcel}
            style={{ fontSize: fixSize, width: fixWidth}}
            icon="pi pi-file-excel"
            onClick={() =>
              exportarExcel({ rows, columns: columnasExcel, filename: `${nombreArchivo}.xlsx`, })
            }
          />
        </Permiso>
      </div>
    )
  };

  const renderHeader = () => {
    const HeadingTag = isPhone ? "h5" : "h4";

    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <HeadingTag className="m-0">Resumen: Recepción de vehículos</HeadingTag>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search pr-2" />
          <InputText 
            value={globalFilterValue} 
            onChange={onGlobalFilterChange}
            className={`pl-5 ${isPhone ? "input-text-s" : ""}`}
            placeholder="Buscar..."
          />
        </IconField>
      </div>
    )
  };

  return (
    <TableLayout titulo="Taller Mecánico" logo={logo} onVolver={() => navigate('/app/taller')}>
      <Toast ref={toast} position="center"/>
      <div className="table-container card">
        <Toolbar className="inv-toolbar gap-2" start={startToolbar} end={endToolbar}></Toolbar>

        <DataTable 
          ref={dt} value={informesFiltrados} dataKey="NumeroOT"
          className="inv-data-table" 
          size="small"
          showGridlines stripedRows 
          sortMode="multiple" removableSort
          selectionMode="single"
          header={renderHeader()} 

          // Barra de busqueda
          filters={filters}
          filteredvalue={filteredvalue.length > 0 ? filteredvalue : null}
          globalFilterFields={[ 
            'NumeroOT', 'Mecanico', 'Mecanico2', 'Servicio', 
            'Patente', 'Marca', 'Modelo',
            'FechaIngreso', 'FechaSalida', 
            'ClienteNombre', 'ClienteRUT', 'ClienteCelular', 
            'Empresa' 
          ]}
          filterDisplay="menu"

          // Paginador config
          paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} informes"
          emptyMessage="No hay informes disponibles."
        >
          <Column field="CreadoEn" header="Creado" body={(row) => formatFecha(row.CreadoEn, '/')} sortable/>
          <Column field="NumeroOT" header="N°OT" style={{ minWidth: '100px' }} sortable/>
          <Column header="Mecánico" body={mecanicoTemplate} align={'center'} sortable/>
          <Column field="Servicio" header="Servicio" align={'center'} sortable/>
          <Column field="Patente" header="Patente" sortable />
          <Column field="Modelo" header="Modelo" sortable/>
          <Column field="Marca" header="Marca" sortable/>
          {/* <Column field="FechaIngreso" header="Fecha Ingreso" align={'center'} style={{ textAlign: 'center', justifyContent: 'center', minWidth: '100px' }} sortable/> */}
          <Column field="FechaIngreso" header="Fecha Ingreso" body={(row) => formatFecha(row.FechaIngreso, '/')} sortable />
          <Column field="FechaSalida" header="Fecha Salida" body={(row) => formatFecha(row.FechaSalida, '/')} sortable />
          <Column header="Cliente" body={clienteTemplate} align={'center'} sortable />
          <Column field="ClienteCelular" header="Celular" sortable/>
          <Column header="Acción" align={'center'} style={{ textAlign: 'center', justifyContent: 'center'}} body={accionTemplate}/>
        </DataTable>
      </div>
    </TableLayout>
  );
}

export default VerInformes;